import { Link } from "react-router-dom";

export const Logo = ({ light = false }) => (
  <Link to="/" data-testid="brand-logo" className="flex items-center gap-2.5 group">
    <img 
      src="/Logo__1_-removebg-preview.png" 
      alt="The Aurge Labs" 
      className={`h-12 md:h-14 w-auto object-contain block transition-opacity ${light ? "brightness-0 invert" : ""}`}
    />
  </Link>
);
